//@flow
import * as Immutable from 'immutable';
import I18nHelper from 'common/helpers/I18nHelper';

import DataUtils from 'common/utils/DataUtils';
import NumberUtils from 'common/utils/NumberUtils';
import {
    validate,
    validatable,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';

import { VisitFrequencyInfo } from 'common/models/flow/VisitFrequencyInfo';
import type { VisitFrequencyInfoModelType } from 'common/models/flow/VisitFrequencyInfo';

const translationsNamespace = ['validations'];

const nsTranslate = I18nHelper.translate.bind(null, translationsNamespace);

@validatable
class InternalVisitFrequencyInfo extends VisitFrequencyInfo {
    static fromJS(
        json: VisitFrequencyInfoModelType
    ): InternalVisitFrequencyInfo {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setDuration(duration: number): this {
        return super.setDuration(duration);
    }

    validateDuration() {
        if (
            !DataUtils.isEmpty(this.duration) &&
            !NumberUtils.isNumeric(this.duration)
        ) {
            return nsTranslate(
                'validations:visitFrequencyInfoValidationErrors.duration.notANumber'
            );
        } else if (
            !DataUtils.isEmpty(this.duration) &&
            !NumberUtils.isPositiveNumber(this.duration)
        ) {
            return nsTranslate(
                'validations:visitFrequencyInfoValidationErrors.duration.notAPositiveNumber'
            );
        }
    }

    @validate
    setRepeatCount(repeatCount: number): this {
        return super.setRepeatCount(repeatCount);
    }

    validateRepeatCount() {
        if (
            !DataUtils.isEmpty(this.repeatCount) &&
            !NumberUtils.isNumeric(this.repeatCount)
        ) {
            return nsTranslate(
                'validations:visitFrequencyInfoValidationErrors.repeatCount.notANumber'
            );
        } else if (
            !DataUtils.isEmpty(this.repeatCount) &&
            !NumberUtils.isPositiveNumber(this.repeatCount)
        ) {
            return nsTranslate(
                'validations:visitFrequencyInfoValidationErrors.repeatCount.notAPositiveNumber'
            );
        }
    }
}

export { InternalVisitFrequencyInfo as VisitFrequencyInfo };
